import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getAuthenticatedState } from '../../AppReducer';
import LoginForm from '../../components/Login/LoginForm';
import { withRoute } from 'util/withRoute';
import { Helmet } from "react-helmet";
import { toggleShowHeader } from '../../AppActions';
import './LoginPage.css';
import logoImg from './logo.png';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.dispatch(toggleShowHeader(false));
    if (this.props.isAuthenticated) {
      this.props.navigate(this.props.redirectUrl);
    }
  }

  componentWillUnmount() {
    this.props.dispatch(toggleShowHeader(true));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isAuthenticated !== this.props.isAuthenticated) {
      this.props.navigate('/dashboard', { replace: true });
    }
  }

  render() {
    return (
      <div className="login-page-container">
        <Helmet>
          <title>VenueMonk Partner — Login</title>
        </Helmet>

        {/* ════ TOPBAR ════ */}
        <nav className="topbar">
          <Link to="/" className="tb-logo">
            <img src={logoImg} alt="VenueMonk" className="login-logo-img" style={{ height: '34px', objectFit: 'contain' }} />
          </Link>
          <div className="tb-right">
            <Link to="/login" className="tb-login-link">LOGIN</Link>
            <Link to="/choose-your-business" className="tb-list-btn">LIST YOUR BUSINESS</Link>
          </div>
        </nav>

        {/* ── MOBILE HERO (orange gradient) ── */}
        <div className="login-hero-mobile">
          <div className="lhm-tagline">Delhi NCR's Biggest Event Planning Platform</div>
          <div className="lhm-headline">Corporate Events<br />Made Easy!</div>
          <div className="lhm-stats">
            <div className="lhm-stat">
              <div className="lhm-stat-num">50+</div>
              <div className="lhm-stat-lbl">Verified Events</div>
            </div>
            <div className="lhm-stat">
              <div className="lhm-stat-num">20000+</div>
              <div className="lhm-stat-lbl">Verified Venues</div>
            </div>
            <div className="lhm-stat">
              <div className="lhm-stat-num">20+</div>
              <div className="lhm-stat-lbl">Category of Events</div>
            </div>
          </div>
        </div>

        {/* ── DESKTOP HERO (background image + floating card) ── */}
        <div className="login-desktop-hero">
          {/* Left: community text + stats */}
          <div className="ldh-left">
            <p className="ldh-community">
              Join a community of 2000+ venue owners and service<br />
              providers who are growing as our business partners.
            </p>
            <div className="ldh-stats">
              <div>
                <div className="ldh-stat-num">20000+</div>
                <div className="ldh-stat-lbl">Verified Events</div>
              </div>
              <div>
                <div className="ldh-stat-num">20000+</div>
                <div className="ldh-stat-lbl">Verified Venues</div>
              </div>
              <div>
                <div className="ldh-stat-num">20+</div>
                <div className="ldh-stat-lbl">Category of Events</div>
              </div>
            </div>
            <Link to="/choose-your-business" className="ldh-list-btn">LIST YOUR BUSINESS</Link>
          </div>

          {/* Right: login card */}
          <div className="ldh-card">
            <LoginForm />
          </div>
        </div>

        {/* ── MOBILE HERO (orange gradient) ── */}
        <div className="login-mobile">
          <div className="login-card-mobile">
            <LoginForm />
          </div>
        </div>

        {/* ── OUR HAPPY CLIENTS ── */}
        <div className="clients-section">
          <div className="clients-title">Our Happy Clients</div>
          <div className="ticker-wrap">
            <div className="ticker-track">
              {/* Ticker Group 1 */}
              <div className="ticker-group">
                <div className="client-logo-wrap client-logo-1img">
                  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="56" height="56" rx="6" fill="#005A64"/>
                    <path d="M 19,19 L 25.5,14 L 31.5,14 L 31.5,33 L 37,33 L 37,36 L 19,36 L 19,33 L 24.5,33 L 24.5,19 Z" fill="white"/>
                    <text x="28" y="48" fill="white" font-family="'Outfit', 'Inter', sans-serif" font-weight="800" font-size="9" text-anchor="middle" letter-spacing="0.05em">1img</text>
                  </svg>
                </div>
                <div className="client-logo-wrap client-logo-cardekho">
                  <svg width="150" height="40" viewBox="0 0 150 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20" cy="20" r="15" fill="#F05A24"/>
                    <circle cx="20" cy="20" r="10" fill="none" stroke="white" stroke-width="2.5"/>
                    <circle cx="20" cy="20" r="3" fill="white"/>
                    <line x1="20" y1="20" x2="20" y2="30" stroke="white" stroke-width="2.5"/>
                    <line x1="20" y1="20" x2="11.34" y2="15" stroke="white" stroke-width="2.5"/>
                    <line x1="20" y1="20" x2="28.66" y2="15" stroke="white" stroke-width="2.5"/>
                    <text x="42" y="23" fill="#111827" font-family="'Outfit', 'Inter', sans-serif" font-weight="800" font-size="20">CarDekho</text>
                    <text x="42" y="31" fill="#4B5563" font-family="'Outfit', 'Inter', sans-serif" font-weight="700" font-size="4" letter-spacing="0.05em">RIGHT CAR, RIGHT NOW</text>
                  </svg>
                </div>
                <div className="client-logo-wrap client-logo-makemytrip">
                  <svg width="150" height="40" viewBox="0 0 150 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <text x="10" y="26" fill="#0E234B" font-family="'Outfit', 'Inter', sans-serif" font-weight="800" font-size="20" letter-spacing="-0.03em">make</text>
                    <rect x="65" y="10" width="30" height="20" rx="4" fill="#E51936"/>
                    <text x="80" y="24" fill="white" font-family="'Outfit', 'Inter', sans-serif" font-weight="800" font-size="12" text-anchor="middle">my</text>
                    <text x="99" y="26" fill="#0E234B" font-family="'Outfit', 'Inter', sans-serif" font-weight="800" font-size="20" letter-spacing="-0.03em">trip</text>
                  </svg>
                </div>
                <div className="client-logo-wrap client-logo-shuttl">
                  <svg width="110" height="40" viewBox="0 0 110 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <text x="10" y="28" fill="#00A2A6" font-family="'Outfit', 'Inter', sans-serif" font-weight="800" font-size="28" letter-spacing="-0.04em">Shuttl</text>
                  </svg>
                </div>
                <div className="client-logo-wrap client-logo-snapdeal">
                  <svg width="150" height="40" viewBox="0 0 150 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g transform="translate(10, 8)">
                      <path d="M11.5 0.5L1.5 5.5V16.5L11.5 21.5L13.5 20.5V9.5L11.5 10.5V18.5L4.5 15V7L11.5 3.5L18.5 7V9.5L20.5 8.5V5.5L11.5 0.5Z" fill="#E40046"/>
                      <path d="M14.5 11.5L21.5 8L22.5 8.5V16.5L14.5 20.5V11.5Z" fill="#E40046"/>
                    </g>
                    <text x="42" y="27" fill="#111827" font-family="'Outfit', 'Inter', sans-serif" font-weight="700" font-size="22" letter-spacing="-0.03em">snapdeal</text>
                  </svg>
                </div>
                <div className="client-logo-wrap client-logo-zs">
                  <svg width="100" height="40" viewBox="0 0 100 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g transform="translate(10, 5)">
                      <polygon points="0,20 3,17 3,29 0,32" fill="#CBD5E0"/>
                      <polygon points="4,16 7,13 7,25 4,28" fill="#A0AEC0"/>
                      <polygon points="8,12 11,9 11,21 8,24" fill="#ED8936"/>
                      <polygon points="12,8 15,5 15,17 12,20" fill="#ED8936"/>
                      <polygon points="16,14 19,11 19,23 16,26" fill="#718096"/>
                      <polygon points="20,20 23,17 23,29 20,32" fill="#A0AEC0"/>
                    </g>
                    <text x="42" y="27" fill="#5A6070" font-family="'Outfit', 'Inter', sans-serif" font-weight="400" font-size="26">ZS</text>
                  </svg>
                </div>
              </div>

              {/* Ticker Group 2 */}
              <div className="ticker-group">
                <div className="client-logo-wrap client-logo-1img">
                  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="56" height="56" rx="6" fill="#005A64"/>
                    <path d="M 19,19 L 25.5,14 L 31.5,14 L 31.5,33 L 37,33 L 37,36 L 19,36 L 19,33 L 24.5,33 L 24.5,19 Z" fill="white"/>
                    <text x="28" y="48" fill="white" font-family="'Outfit', 'Inter', sans-serif" font-weight="800" font-size="9" text-anchor="middle" letter-spacing="0.05em">1img</text>
                  </svg>
                </div>
                <div className="client-logo-wrap client-logo-cardekho">
                  <svg width="150" height="40" viewBox="0 0 150 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20" cy="20" r="15" fill="#F05A24"/>
                    <circle cx="20" cy="20" r="10" fill="none" stroke="white" stroke-width="2.5"/>
                    <circle cx="20" cy="20" r="3" fill="white"/>
                    <line x1="20" y1="20" x2="20" y2="30" stroke="white" stroke-width="2.5"/>
                    <line x1="20" y1="20" x2="11.34" y2="15" stroke="white" stroke-width="2.5"/>
                    <line x1="20" y1="20" x2="28.66" y2="15" stroke="white" stroke-width="2.5"/>
                    <text x="42" y="23" fill="#111827" font-family="'Outfit', 'Inter', sans-serif" font-weight="800" font-size="20">CarDekho</text>
                    <text x="42" y="31" fill="#4B5563" font-family="'Outfit', 'Inter', sans-serif" font-weight="700" font-size="4" letter-spacing="0.05em">RIGHT CAR, RIGHT NOW</text>
                  </svg>
                </div>
                <div className="client-logo-wrap client-logo-makemytrip">
                  <svg width="150" height="40" viewBox="0 0 150 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <text x="10" y="26" fill="#0E234B" font-family="'Outfit', 'Inter', sans-serif" font-weight="800" font-size="20" letter-spacing="-0.03em">make</text>
                    <rect x="65" y="10" width="30" height="20" rx="4" fill="#E51936"/>
                    <text x="80" y="24" fill="white" font-family="'Outfit', 'Inter', sans-serif" font-weight="800" font-size="12" text-anchor="middle">my</text>
                    <text x="99" y="26" fill="#0E234B" font-family="'Outfit', 'Inter', sans-serif" font-weight="800" font-size="20" letter-spacing="-0.03em">trip</text>
                  </svg>
                </div>
                <div className="client-logo-wrap client-logo-shuttl">
                  <svg width="110" height="40" viewBox="0 0 110 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <text x="10" y="28" fill="#00A2A6" font-family="'Outfit', 'Inter', sans-serif" font-weight="800" font-size="28" letter-spacing="-0.04em">Shuttl</text>
                  </svg>
                </div>
                <div className="client-logo-wrap client-logo-snapdeal">
                  <svg width="150" height="40" viewBox="0 0 150 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g transform="translate(10, 8)">
                      <path d="M11.5 0.5L1.5 5.5V16.5L11.5 21.5L13.5 20.5V9.5L11.5 10.5V18.5L4.5 15V7L11.5 3.5L18.5 7V9.5L20.5 8.5V5.5L11.5 0.5Z" fill="#E40046"/>
                      <path d="M14.5 11.5L21.5 8L22.5 8.5V16.5L14.5 20.5V11.5Z" fill="#E40046"/>
                    </g>
                    <text x="42" y="27" fill="#111827" font-family="'Outfit', 'Inter', sans-serif" font-weight="700" font-size="22" letter-spacing="-0.03em">snapdeal</text>
                  </svg>
                </div>
                <div className="client-logo-wrap client-logo-zs">
                  <svg width="100" height="40" viewBox="0 0 100 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g transform="translate(10, 5)">
                      <polygon points="0,20 3,17 3,29 0,32" fill="#CBD5E0"/>
                      <polygon points="4,16 7,13 7,25 4,28" fill="#A0AEC0"/>
                      <polygon points="8,12 11,9 11,21 8,24" fill="#ED8936"/>
                      <polygon points="12,8 15,5 15,17 12,20" fill="#ED8936"/>
                      <polygon points="16,14 19,11 19,23 16,26" fill="#718096"/>
                      <polygon points="20,20 23,17 23,29 20,32" fill="#A0AEC0"/>
                    </g>
                    <text x="42" y="27" fill="#5A6070" font-family="'Outfit', 'Inter', sans-serif" font-weight="400" font-size="26">ZS</text>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="cta-section">
          <div className="cta-title">Join Us to Grow Your Business</div>
          <Link to="/choose-your-business" className="cta-btn">Get Started</Link>
        </div>

        {/* FOOTER */}
        <footer className="footer">
          <div className="footer-grid">
            <div>
              <div className="fc-title">Information</div>
              <span className="fc-link">Contact Us</span>
              <span className="fc-link">Careers</span>
              <span className="fc-link">Support</span>
              <span className="fc-link">Why VenueMonk</span>
            </div>
            <div>
              <div className="fc-title">Company Details</div>
              <span className="fc-link">About Us</span>
              <Link to="/terms" className="fc-link">Privacy Policy</Link>
              <Link to="/terms" className="fc-link">Terms of Use</Link>
              <span className="fc-link">Blogs</span>
            </div>
            <div>
              <div className="fc-title">Partner with us</div>
              <span className="fc-text">One liner content</span>
              <div className="app-btns">
                <div className="web-btn">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20" cy="20" r="20" fill="#111827"/>
                    <circle cx="20" cy="20" r="10" stroke="white" strokeWidth="1.5"/>
                    <path d="M20 10C20 10 23 14 23 20C23 26 20 30 20 30" stroke="white" strokeWidth="1.5"/>
                    <path d="M20 10C20 10 17 14 17 20C17 26 20 30 20 30" stroke="white" strokeWidth="1.5"/>
                    <path d="M10.5 17H29.5" stroke="white" strokeWidth="1.5"/>
                    <path d="M10.5 23H29.5" stroke="white" strokeWidth="1.5"/>
                  </svg>
                </div>
                <a href="https://play.google.com/store/games?device=windows" target="_blank" rel="noopener noreferrer" className="play-btn">
                  <svg width="135" height="40" viewBox="0 0 135 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="135" height="40" rx="6" fill="#000000"/>
                    <g transform="translate(10, 8)">
                      <path d="M1.5 0.5C1.0 0.8 0.8 1.3 0.8 2.0V22.0C0.8 22.7 1.0 23.2 1.5 23.5L12.5 12.5L1.5 0.5Z" fill="#00E5FF"/>
                      <path d="M16.5 8.5L12.5 12.5L1.5 23.5C1.8 23.8 2.4 23.8 3.0 23.4L17.5 15.1C18.5 14.5 18.5 13.5 17.5 12.9L16.5 8.5Z" fill="#FFC107"/>
                      <path d="M1.5 0.5C2.4 0.2 3.0 0.2 3.0 0.6L17.5 8.9C18.5 9.5 18.5 10.5 17.5 11.1L12.5 12.5L1.5 0.5Z" fill="#FF3D00"/>
                      <path d="M12.5 12.5L16.5 8.5L17.5 8.9C18.5 9.5 18.5 10.5 17.5 11.1L16.5 12.5L12.5 12.5Z" fill="#4CAF50"/>
                    </g>
                    <text x="40" y="15" fill="white" fontFamily="'Outfit', 'Inter', sans-serif" fontWeight="700" fontSize="8" letterSpacing="0.05em">GET IT ON</text>
                    <text x="40" y="28" fill="white" fontFamily="'Outfit', 'Inter', sans-serif" fontWeight="800" fontSize="14">Google Play</text>
                  </svg>
                </a>
              </div>
            </div>
            <div>
              <div className="fc-title">Follow us on</div>
              <div className="social-row">
                <a href="https://www.facebook.com/venuemonk" target="_blank" rel="noopener noreferrer" className="social-icon-btn">
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="18" cy="18" r="17" fill="white" stroke="#E5E7EB" strokeWidth="1.2"/>
                    <path d="M20.5 18H18.5V25H15.5V18H14V15H15.5V13.5C15.5 11.5 16.5 10.5 18.5 10.5C19.5 10.5 20.2 10.6 20.5 10.7V13.3H19.2C18.2 13.3 18.0 13.7 18.0 14.5V15H20.5L20.5 18Z" fill="#612B88"/>
                  </svg>
                </a>
                <a href="https://x.com/venuemonk" target="_blank" rel="noopener noreferrer" className="social-icon-btn">
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="18" cy="18" r="17" fill="white" stroke="#E5E7EB" strokeWidth="1.2"/>
                    <path d="M23.5 10H25L19.5 16.3L26 25H21.5L18 20.3L14 25H12.5L18.3 18.3L12 10H16.5L19.7 14.3L23.5 10ZM22.5 23.5H23.3L15.5 11.5H14.7L22.5 23.5Z" fill="#612B88"/>
                  </svg>
                </a>
                <a href="https://www.instagram.com/venuemonk" target="_blank" rel="noopener noreferrer" className="social-icon-btn">
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="18" cy="18" r="17" fill="white" stroke="#E5E7EB" strokeWidth="1.2"/>
                    <rect x="11" y="11" width="14" height="14" rx="4" stroke="#612B88" strokeWidth="1.8"/>
                    <circle cx="18" cy="18" r="3.5" stroke="#612B88" strokeWidth="1.8"/>
                    <circle cx="21.5" cy="14.5" r="0.8" fill="#612B88"/>
                  </svg>
                </a>
                <a href="https://in.pinterest.com/VenueMonk/" target="_blank" rel="noopener noreferrer" className="social-icon-btn">
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="18" cy="18" r="17" fill="white" stroke="#E5E7EB" strokeWidth="1.2"/>
                    <circle cx="18" cy="18" r="10" fill="#612B88" />
                    <g transform="translate(12.5, 10.5) scale(0.028)">
                      <path d="M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z" fill="white"/>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <strong>VenueMonk 0.2.62</strong><br />
            Copyright© 2026 VenueMonk Technologies Private Limited
          </div>
        </footer>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state, props) {
  return {
    redirectUrl: props.location && props.location.query.ref ? props.location.query.ref : '',
    isAuthenticated: getAuthenticatedState(state),
  };
}

LoginPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  router: PropTypes.object,
};

export default connect(mapStateToProps)(withRoute(LoginPage));
